import Main from '@/pages/Info/Main'
import Message from '@/pages/Info/Message'
import Safe from '@/pages/Info/Safe'
import Password from '@/pages/Info/Password'
import PayPassword from '@/pages/Info/PayPassword'
import Step1 from '../pages/Info/Step1'
import Step2 from '../pages/Info/Step2'
import Services from '../pages/Info/Services'
import AddService from '../pages/Info/AddService'
import ModCard from '../pages/Info/ModCard'
import ProSetting from '../pages/Info/ProSetting'
import Members from '../pages/Info/Members'
import Roles from '../pages/Info/Roles'
import EditMember from '../pages/Info/EditMember'
import Phone from '../pages/Info/Phone'
import PStep1 from '../pages/Info/PStep1'
import PStep2 from '../pages/Info/PStep2'
import Mail from '../pages/Info/Mail'
import MStep1 from '../pages/Info/MStep1'
import MStep2 from '../pages/Info/MStep2'

export default [
    {
        path: '',
        component: Main
    },
    {
        path: 'main',
        component: Main
    },
    {
        path: 'message',
        component: Message
    },
    {
        path: 'safe',
        component: Safe
    },
    {
        path: 'password',
        component: Password
    },
    {
        path: 'services',
        component: Services
    },
    {
        path: 'addservice',
        component: AddService
    },
    {
        path: 'modcard',
        component: ModCard
    },
    {
        path: 'paypassword',
        component: PayPassword,
        children: [{
            path: '',
            redirect: 'step1'
        }, {
            path: 'step1',
            component: Step1
        }, {
            path: 'step2',
            component: Step2
        }]
    },
    {
        path: 'prosetting',
        component: ProSetting
    },
    {
        path: 'members',
        component: Members
    },
    {
        path: 'roles',
        component: Roles
    },
    {
        path: 'editmember',
        component: EditMember
    },
    {
        path: 'phone',
        component: Phone,
        children: [
            {
                path: '',
                redirect: 'step1'
            },
            {
                path: 'step1',
                component: PStep1
            },
            {
                path: 'step2',
                component: PStep2
            }
        ]
    },
    {
        path: 'mail',
        component: Mail,
        children: [
            {
                path: '',
                redirect: 'step1'
            },
            {
                path: 'step1',
                component: MStep1
            },
            {
                path: 'step2',
                component: MStep2
            }
        ]
    },
    {
        path: 'notification',
        component: () => import('../pages/Info/Notification')
    }
]
